export default "__VITE_ASSET__DTRi6G7L__"